import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { SignInfo } from 'domain-models/SignInfo';
import { Helper } from 'libraries/Helper';
import MultistringUtils from 'libraries/MultistringUtils';
import { Page } from 'libraries/Page';
import { FontsService } from 'services/fonts/fonts.service';
// import { Socket } from 'ng-socket-io';

@Component({
	selector: 'app-sign',
	templateUrl: './sign.component.html',
	styleUrls: ['./sign.component.css'],
	encapsulation: ViewEncapsulation.None
})
export class SignComponent implements OnInit {
	@Input('sign') sign: SignInfo;
	@Input() selected: boolean;

	// private _sign : SignInfo;
	// public get sign() : SignInfo {
	//   return this._sign;
	// }
	// @Input('sign') public set sign(v : SignInfo) {
	//   if(this._sign!=v){
	//     this._sign = v;
	//     this.ngOnInit();
	//   }
	// }

	@Input('groupName') groupName: string;
	@Output() signClicked = new EventEmitter<{ id: number; isSelected: boolean }>();
	parsedMultistring: Array<Page>;
	currentPageMessage: string;
	loading: boolean = false;
	private currentPage: number;
	compressedFont: boolean = false;
	signWidth: any;
	predefinedImage;

	constructor(
		private fontsService: FontsService // private socket: Socket
	) {}

	ngOnInit() {
		// console.log(this.groupName);
		this.loading = true;

		this.parsedMultistring = MultistringUtils.parse(this.sign, this.fontsService);
		setTimeout(() => {
			// console.log(this.parsedMultistring);
			// if(this.sign.Id === 1134463157){
			//   console.log('hello');
			// }
			// console.log(MultistringUtils.construct(this.parsedMultistring));
			this.currentPage = -1;
			this.updatePage();
			this.loading = false;
		}, 20);
	}

	onChange() {
		// console.log(this.sign.isSelected);
		// this.signClicked.emit({ id: this.sign.Id, isSelected: this.selected });
	}
	canBeControlled() {
		if (this.sign.Status == 'Online' && this.sign.SignCanControl) {
			this.signClicked.emit({ id: this.sign.Id, isSelected: !this.selected });
		} else if (this.sign.Status == 'Offline') {
			Helper.alert('This sign is <b>' + this.sign.Status + '</b> so it can <b>NOT</b> be selected');
		} else {
			Helper.alert('You can NOT control this sign.');
		}
	}

	updatePage() {
		this.currentPage++;
		if (this.currentPage === this.parsedMultistring.length) {
			this.currentPage = 0;
		}

		let page = this.parsedMultistring[this.currentPage];
		// let lines = page.lines.map(line => line.text);
		// let pageText = lines.join('<br>');

		// Show image if it's got one
		if (page.imageResource) {
			this.predefinedImage = `./assets/img/sign/${page.imageResource}.png`;
			this.currentPageMessage = '';
		} else {
			this.predefinedImage = undefined;
			let justifiedLines = page.lines.map((line, index) => {
				let lineText = `<div class="sign__line clearfix">`;
				if (line.justifications[2]) {
					lineText += `<span class="align pull-left">${line.justifications[2]}</span>`;
				}
				if (line.justifications[3]) {
					lineText += line.justifications[3];
				}
				if (line.justifications[4]) {
					lineText += `<span class="align pull-right">${line.justifications[4]}</span>`;
				}
				lineText += '</div>';
				return lineText;
			});

			this.currentPageMessage = justifiedLines.join('');
		}
		// This condition (sign.ModulePerLine === 8) was added for Boise city (Addco) sigs that
		// only accepts font1, which might be a compressed font or may not. As of now there is no
		// interface to manage fonts for Addco sign, and because it only deals with font1, which is normally
		// the 7x5 font not compressed, then we need to fool the code to show it as compressed even though
		// its NTCIP tag shows fo1. The reason we are doing this to fit the message properly in the view.
		if (
			(page.font && page.font.Id == 2) ||
			this.sign.ModulePerLine === 18 ||
			this.sign.ModulePerLine === 8
		) {
			this.compressedFont = true;
		}

		this.signWidth = {
			'letter-spacing': '1px',
			'line-height': '1.1',
			width: `${(this.sign.ModulePerLine / 1.5) * (this.compressedFont ? 1 / 0.7 : 1)}em`
		};

		if (this.parsedMultistring.length > 1) {
			setTimeout(this.updatePage.bind(this), (page.flashOn || 20) * 100);
		}
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/display/display-section/sign/sign.component.ts